// Entry point: language first (no flash of English), then the composition root, then the UI. The service worker is
// registered in production builds only.

import { effect } from '@preact/signals';
import { render } from 'preact';
import './ui/styles.css';
import { initI18n, setLocale, resolveLanguage } from './i18n';
import { unitPreference } from './i18n/format';
import { prefs } from './storage/prefs';
import { App } from './ui/App';
import { AppEnv, EnvContext } from './ui/env';
import { registerServiceWorker } from './sw/register';

async function main() {
  await initI18n(prefs.language.value);
  // Language and units follow the preferences live (More › Settings).
  effect(() => {
    const code = resolveLanguage(prefs.language.value);
    void setLocale(code);
  });
  effect(() => {
    unitPreference.value = prefs.unitSystem.value;
  });
  effect(() => {
    const theme = prefs.theme.value;
    if (theme === 'system') document.documentElement.removeAttribute('data-theme');
    else document.documentElement.setAttribute('data-theme', theme);
  });

  const env = new AppEnv();
  const root = document.getElementById('app')!;
  render(
    <EnvContext.Provider value={env}>
      <App />
    </EnvContext.Provider>,
    root,
  );
  await env.start();
  registerServiceWorker();
}

void main();
